module.exports = __webpack_public_path__ + "static/img/sanyecao.3e16eee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/sanyecao.jpg
// module id = enjF
// module chunks = 1